<template>
  <div class="main">
    <Loading v-if="loading" />
    <ServerMessage v-if="snackbar" />
    <PageHeader class="header" />
    <AppFooter class="mainfooter" />
    <div class="mainBody">
      <v-card class="card" width="500">
        <v-card-title class="title font-weight-regular justify-space-between">
          <b class="titleB"> Sign in to your account</b>
        </v-card-title>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12">
              <v-text-field
                autofocus
                type="number"
                v-model="walletId"
                :error-messages="walletIdErrors"
                label="Enter your teller ID or phone number *"
                filled
                shaped
                required
                @input="$v.walletId.$touch()"
                @blur="$v.walletId.$touch()"
              ></v-text-field>
              <v-text-field
                @keyup.enter="enterClicked()"
                type="password"
                v-model="pin"
                :error-messages="PinErrors"
                label="Enter your Teller Pin *"
                filled
                shaped
                required
                @input="$v.pin.$touch()"
                @blur="$v.pin.$touch()"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-card-actions>
            <div @click="navigate('signup')" class="login">
              <p>Don’t have an account ? <b> Sign Up</b></p>
            </div>
            <v-spacer></v-spacer>
            <v-btn @click="LoginFuc()" dark class="nextBtn">
              Log in
              <v-icon right dark>mdi-arrow-right</v-icon>
            </v-btn>
          </v-card-actions>
        </v-container>
        <div @click="navigate('login')" class="ForgotPin">
          <small>Forgot Pin</small>
        </div>
        <div @click="navigate('login')" class="ForgotPin">
          <p class="redm">{{ serverMessage }}</p>
        </div>
      </v-card>
    </div>
    <div class="mainBodytwo">
      <img
        src="../assets/login.png"
        alt="teller logo"
        width="80%"
        height="90%"
      />
    </div>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import PageHeader from "../components/Header";
import AppFooter from "../components/AppFooter";
export default {
  mixins: [validationMixin],
  metaInfo: {
    title: "Teller/Login",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "Teller.ng",
        content:
          "Teller.ng provides online payment settlement system which allows instant money transfer, bill payment, and airtime purchases. It’s safe, reliable and most importantly, hassle-free.Teller helps you to pay your electricity, cable, internet and other bills with ease.  For convenient airtime recharge, funds transfer, bills payments. Making your everyday payment simple, safe and secure.",
      },
    ],
  },

  validations: {
    walletId: { required },
    pin: { required },
  },
  components: {
    PageHeader,
    AppFooter,
  },
  created() {
    let payload = {
      status: false,
      message: "",
    };
    this.$store.dispatch("SnackbarFunc", payload);
  },

  destroyed() {
    let payload = {
      status: false,
      message: "",
    };
    this.$store.dispatch("SnackbarFunc", payload);
  },

  data: () => ({
    pin: "",
    walletId: "",
    name: "",
  }),
  methods: {
    enterClicked() {
      this.LoginFuc();
    },
    navigate(to) {
      this.$router.push({ name: to });
    },
    LoginFuc() {
      if (this.walletId == "" || this.pin == "") {
        let payload = {
          status: true,
          message: "walletId and pin are required",
        };
        this.$store.dispatch("SnackbarFunc", payload);
        return;
      }
      let payload = {
        pin: this.pin,
        walletId: this.walletId,
        route: this.$router,
        redirect: this.$route.query.redirect,
      };
      this.$store.dispatch("LoginFuc", payload);
    },
  },
  computed: {
    serverMessage() {
      return this.$store.state.User.serverMessage;
    },
    PinErrors() {
      const errors = [];
      if (!this.$v.pin.$dirty) return errors;
      !this.$v.pin.required && errors.push("Pin is required.");
      return errors;
    },
    walletIdErrors() {
      const errors = [];
      if (!this.$v.walletId.$dirty) return errors;
      !this.$v.walletId.required && errors.push("walletId is required.");
      return errors;
    },
    loading() {
      return this.$store.state.User.loading;
    },
    snackbar() {
      return this.$store.state.User.snackbar;
    },
  },
};
</script>

<style scoped>
.main {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: minmax(57px, auto);
  margin: 0 auto;
  padding: 0px;
  grid-template-areas:
    "header header header header"
    "mainBody mainBody mainBodytwo mainBodytwo"
    "mainBody mainBody mainBodytwo mainBodytwo"
    "mainBody mainBody mainBodytwo mainBodytwo"
    "mainBody mainBody mainBodytwo mainBodytwo"
    "mainBody mainBody mainBodytwo mainBodytwo"
    "mainBody mainBody mainBodytwo mainBodytwo"
    "mainBody mainBody mainBodytwo mainBodytwo"
    "mainBody mainBody mainBodytwo mainBodytwo"
    "mainBody mainBody mainBodytwo mainBodytwo"
    "mainBody mainBody mainBodytwo mainBodytwo"
    "mainfooter mainfooter mainfooter mainfooter";
}

.header {
  grid-area: header;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
}
.redm {
  color: red;
}
.mainBody {
  grid-area: mainBody;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mainBodytwo {
  grid-area: mainBodytwo;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card {
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 16px 50px 0 rgba(189, 36, 39, 0.11);
  background-color: #ffffff;
}
.ForgotPin {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
.ForgotPin small {
  color: #283a90;
  cursor: pointer;
}
.nextBtn {
  background-color: #ad1684 !important;
  border-radius: 5px;
  text-transform: none;
}
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.login p {
  color: #ad1684;
  font-family: "AvenirLTProMedium";
}
.titleB {
  color: #ad1684 !important;
  font-family: "AvenirLTProBlack";
}
@media only screen and (max-width: 700px) {
  .main {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: minmax(50px, auto);
    margin: 10 auto;
    padding: 10px;
    grid-template-areas:
      "header header header header"
      "mainBody mainBody mainBody mainBody"
      "mainBodytwo mainBodytwo mainBodytwo mainBodytwo"
      "mainfooter mainfooter mainfooter mainfooter";
  }
}
</style>
